module.exports = __webpack_public_path__ + "static/media/infoSubject.26d0ae21.jpg";